<div class="header-text">
  <div class="title">
    <ng-content select="gax-page-header-title"></ng-content>
  </div>
  <ng-content select="gax-page-header-description"></ng-content>
</div>
<ng-content select="gax-page-header-actions"></ng-content>
